// Repeat launches from the Experiment page (2026-11-03): the form stays filled after a launch, the name
// steps its trailing number, and every experiment launched from the page keeps its own progress row.
// Pure helpers, unit-tested in launchModel.test.js.

// "loadtest-N4-1" -> "loadtest-N4-2"; zero padding is kept ("run-09" -> "run-10"). No trailing number ->
// unchanged.
export function nextName(name) {
  const m = /^(.*?)(\d+)$/.exec(name || "");
  if (!m) return name;
  const n = String(parseInt(m[2], 10) + 1);
  return m[1] + n.padStart(m[2].length, "0");
}

// Insert or update one launched experiment's row (newest first). `job` is a GET /api/jobs/{id} body.
export function upsertLaunch(launches, id, name, job) {
  const row = { id, name, job };
  return launches.some((l) => l.id === id)
    ? launches.map((l) => (l.id === id ? row : l))
    : [row, ...launches];
}

// Runs that ended without a complete result: a launch error, or a summary that is not complete.
export function failedRuns(job) {
  return ((job && job.results) || []).filter((r) => r.error || (r.summary && r.summary.status !== "complete")).length;
}

// Chip tone for a job status.
export function statusTone(status) {
  if (status === "complete") return "ok";
  if (status === "error" || status === "blocked") return "bad";
  if (status === "cancelled") return "n";
  return "warn";   // preparing / running
}

// The overlay banner's error text once a launch leaves "preparing", or null when it went on to run.
export function launchError(job) {
  if (!job) return null;
  if (job.status === "error") return job.error || "Launch failed.";
  if (job.status === "blocked") return job.error || "Launch blocked.";
  return null;
}
